import FlashMessage from '../common/flash-message.component'
import ErrorCdMsgConstants from '../constants/error-cd-msg.constants'
export default class FileReaderUtils {
  /**
   * FileReader API を使用してファイルの内容を非同期的に読み取ります。
   *
   * @param {*} file 読み取るファイルオブジェクト
   * @returns ファイルが正常に読み取られた場合に「true」に解決される Promise です。読み取りプロセス中にエラーが発生した場合は「false」。
   */
  static readFileAsync(file) {
    return new Promise((resolve) => {
      const fileReader = new FileReader()
      fileReader.onloadstart = event => {
        resolve(true)
      }
      fileReader.onerror = event => {
        if (
          event &&
          event.currentTarget &&
          event.currentTarget.error &&
          event.currentTarget.error.name
        ) {
          // ファイルをアップロードする際に、ファイルの内容が変更された場合
          if (event.currentTarget.error.name.includes('NotReadableError')) {
            FlashMessage.getInstance().showErrorMsgWithErrorCode(
              ErrorCdMsgConstants.FUNC_CSV_FILE_MODIFIED_ERR_CD,
              ErrorCdMsgConstants.FUNC_CSV_FILE_MODIFIED_ERR_MSG
            )
          } else {
            // ファイルをアップロードする際に、ファイルが見つからない場合（削除された、または名前が変更されたなど）
            FlashMessage.getInstance().showErrorMsgWithErrorCode(
              ErrorCdMsgConstants.FUNC_CSV_FILE_NOT_FOUND_ERR_CD,
              ErrorCdMsgConstants.FUNC_CSV_FILE_NOT_FOUND_ERR_MSG
            )
          }
        }
        resolve(false)
      }
      fileReader.readAsArrayBuffer(file)
    })
  }
}



// WEBPACK FOOTER //
// ./src/_helpers/file-reader.util.js